(function($){
  $(function(){

    /**
     * WOVN.ioサービスで言語選択のときのカレント言語処理
     * wovnのイベントは以下にリファレンスあり
     * https://wovn.io/support/wovn-io-javascript/?wovn=ja
     */

     /**
      * 言語選択の仕様で一つのIDにしかバインドできないのCloneする
      */
     var hamburgPoint = window.matchMedia('(max-width:1100px)').matches;
     var wovnSwitcherClone = function(){
       $target = $('#wovn-languages');
       if(hamburgPoint){
         $target.clone().appendTo('.language_box_sp');
       }else{
         $target.clone().appendTo('.pcmask');
       }
       $target.remove();
     }();


     /**
      * 自動翻訳noticeツールチップコントロール
      */
      var autoTransformNoticeVisible = function(){
        $self = $('.oc-auto_transform_notice');
        $self.addClass('window_visible');
        $self.on('AnimationEnd webkitAnimationEnd', function(){
          $self.removeClass('window_visible');
        });
      }



     /**
      * 現在の言語設定部分のクリックイベント消す
      */
     $('a.open_select_language').each(function(){
       $(this).on('click',function(event){
         event.preventDefault();
         return false;
       });
     });
     /**
      * currentの言語をメニューにレンダリング
      */
      $('#wovn-languages a').each(function(){
        var langValue = $(this).data('value');
        var langText;
        switch (langValue){
          case 'en':
            langText = 'EN';
            break;
          case 'ko':
            langText = '한국';
            break;
          case 'zh-CHS':
            langText = '简体';
            break;
          case 'zh-CHT':
            langText = '繁體';
            break;
         default:
            langText = 'JP'
            break;
        }
        $(this).on('click',function(){
          $('a.open_select_language .current_language,.utility_box_trigger .current_language').text(langText);
          var $spMenu = $('[data-menu-toggle="mega_sp"]').eq(0);
          var $arrow = $('[data-language-trigger]').children('.c-icon');

          var isSearchPage = function (pathname, search, lang) {
            function getLangKey (str, l) {
              var p;
              if (str.indexOf('lang=') > -1) {
                p = str.indexOf('lang=') + 4;
                str = str.replace('?', '');
                add = (str.indexOf('query=') > -1) ? '&' + str.substring(str.indexOf('query='), str.length) : '';
                return '?' + str.substring(0, p) + l + add;
              } else {
                p = (str !== '') ? '&' + str.replace('?', '') : '';
                return '?lang=' + lang +  p;
              }
            }
            function makeHref (path, s) {
              var l = (lang !== 'ja') ? '/' + lang : '';
              function makeStr (arr) {
                return arr.slice(arr.indexOf('site_search'), arr.length);
              };
              return l + '/' + makeStr(path.split('/')).join('/') + getLangKey(s, lang);
            }
            if (pathname.indexOf('search.php') > -1) location.href = location.origin + makeHref(pathname, search);
          }(location.pathname, location.search, $(this).attr('data-value'));

          var closeMenu = function(){
            $spMenu.removeClass('is-open');
            $arrow.removeClass('rotate90');
            $('[data-util-extend-box]').each(function(){
    					$(this).removeClass('box_height',300);
            });
          }();

          OH.settings.menuControl.headerModalClose();

          if(langValue != 'ja'){
            $('#auto_transform_notice').addClass('is-visible');
          }else if(langValue = 'ja'){
            $('#auto_transform_notice').removeClass('is-visible');
          }
          // if(langValue != 'ja'){
          //   autoTransformNoticeVisible();
          // }
        })
      });

    /**
     * ページローディング時に設定されている言語にヘッダーの言語選択をカレントにする
     */
     var currentLangs = function(langMode){
      //  var currentLang = $('html').attr('lang') ? $('html').attr('lang') : 'ja';
       var currentLang = langMode;
       var langText;
       switch (currentLang){
         case 'en':
           langText = 'EN';
           break;
         case 'ko':
           langText = '한국';
           break;
         case 'zh-CHS':
           langText = '简体';
           break;
         case 'zh-CHT':
           langText = '繁體';
           break;
        default:
           langText = 'JP';
           break;
       }
       $('a.open_select_language .current_language,.utility_box_trigger .current_language').text(langText);
     }
     window.addEventListener('wovnApiReady', function(evt) {
       try{
         var currentLangMode = WOVN.io.getCurrentLang().code;
       }catch(elseFlg){
         var currentLangMode = 'ja';
       }
       setTimeout(currentLangs(currentLangMode),100);
     });

     /**
      * ■■■ 自動翻訳をしています文言のコントロール
      */
      window.addEventListener('wovnApiReady', function(evt) {
        var currentLangMode;
        try{
          currentLangMode = WOVN.io.getCurrentLang().code;
        }catch(elseFlg){
          currentLangMode = 'ja';
        }
        if(currentLangMode != 'ja'){
          $('#auto_transform_notice').addClass('is-visible');
        } else if(currentLangMode = 'ja'){
          $('#auto_transform_notice').removeClass('is-visible');
        }
        // if(currentLangMode != 'ja'){
        //   autoTransformNoticeVisible();
        // }
      });

    /**
     * ■■■ 検索結果の言語パラメーター付与
     */
    var applyLangParam = function (event) {
      var isReady = ~event.type.indexOf('wovnApiReady');
      var lang = WOVN.io.getCurrentLang().code;
      var hiddenInput = '<input class="wovn-hidden" type="hidden" name="lang" value="' + lang + '">';
      var $forms = $('#site-search-header, #site-search-pcheader, #site-search-dx');
      if (isReady) {
        window.removeEventListener('wovnApiReady', applyLangParam);
        $forms.prepend(hiddenInput);
      } else {
        $('.wovn-hidden').val(lang);
      }
    };
    window.addEventListener('wovnApiReady', applyLangParam);
    window.addEventListener('wovnLangChanged', applyLangParam);

  });
})(jQuery);
